import { editStatusFilter, funderFilter, unitIdentifierFilter } from '../../Vocabulary/data';
import { QueryFacet } from '../../pages/dashboard/SearchResults';
import { FacetLabel, FacetSetting } from '../../util/types';
import { idHashFilter } from '../../pages/dashboard/utils';
import { HierarchyEntity } from '../data';

export const projectFacetsSettings: FacetSetting[] = [
  {
    name: 'f_top_orga',
    label: 'search.facet.project.top_orga',
    missingLabel: 'search.facet.project.top_orga.missing',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => idHashFilter(label, HierarchyEntity.ORGS),
  },
  {
    name: 'f_project',
    label: 'search.facet.project.project',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => idHashFilter(label, HierarchyEntity.PROJECTS),
  },
  {
    name: 'f_partner',
    label: 'search.facet.project.partner',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => idHashFilter(label, HierarchyEntity.ORGS),
  },
  {
    name: 'f_funder',
    label: 'search.facet.project.funder',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => funderFilter(label),
  },
  {
    name: 'f_external_identifier',
    label: 'search.facet.project.external_identifier',
    tristate: true,
    parse: (facet: QueryFacet): string => `${facet.factor === false ? '-' : ''}${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => unitIdentifierFilter(label),
  },
  {
    name: 'f_editorial_status',
    label: 'search.facet.project.editorial_status',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => editStatusFilter(label),
  },
];
